<template>
  <div
    class="c-serviceListItem"
    :class="`c-serviceListItem${layoutType}`"
  >
    <div
      class="c-serviceListItem_inner c-serviceListItemRow"
      :class="`c-serviceListItem${layoutType}_inner`"
    >
      <div
        class="c-serviceListItemCol c-serviceListItemColUser"
        v-if="isPC"
      >
        <div class="c-serviceListItemColUser_icon">
          <c-user-icon-v2
            :file-path="service.provider.profileIconPath"
            :size="50"
            :width="100"
            :height="100"
          />
        </div>

        <div
          class="c-serviceListItemColUser_certificationIcon"
          v-if="isDisplayCertificationIcon"
        >
          <ProIcon
            v-if="service.service.proServiceFlag"
            width="30px"
          />
          <DivinationIcon
            v-else-if="service.service.certificationDivinationServiceFlag"
            width="30px"
          />
        </div>

        <div class="c-serviceListItemColUser_labels">
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-standby"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneWait"
          >
            <div class="c-serviceListItemColUserLabel_label">今すぐ<br>相談可能</div>
          </div>
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-reserve"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.service.reservationAvailableFlag"
          >
            <div class="c-serviceListItemColUserLabel_label">予約<br>受付中</div>
          </div>
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-busy"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneTalking"
          >
            <div class="c-serviceListItemColUserLabel_label">相談中</div>
          </div>
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-away"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.isProviderAway"
          >
            <div class="c-serviceListItemColUserLabel_label">離席中</div>
          </div>
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-limit"
            v-if="service.service.fullCorrespondenceFlag"
          >
            <div class="c-serviceListItemColUserLabel_label">満枠<br>対応中</div>
          </div>
          <div
            class="c-serviceListItemColUserLabel c-serviceListItemColUserLabel-stop"
            v-if="service.service.stopFg"
          >
            <div class="c-serviceListItemColUserLabel_label">受付<br>休止中</div>
          </div>
        </div>
      </div>
      <div class="c-serviceListItemCol c-serviceListItemColContent">
        <div class="c-serviceListItemColContent_header c-serviceListItemColContentHeader">
          <div
            class="c-serviceListItemColContentHeader_title"
            :class="{
              'c-serviceListItemColContentHeader_title-withIcon': (isSP || isTB) && isDisplayCertificationIcon
            }"
          >
            <div
              class="c-serviceListItemColContentHeader_certificationIcon"
              v-if="(isSP || isTB) && isDisplayCertificationIcon"
            >
              <ProIcon
                v-if="service.service.proServiceFlag"
                width="24px"
              />
              <DivinationIcon
                v-else-if="service.service.certificationDivinationServiceFlag"
                width="24px"
              />
            </div>
            <template v-if="service.service.overview">
              <div
                class="c-serviceListItemColContentHeader_firstLine"
                :class="{
                  'c-serviceListItemColContentHeader_firstLine-withIcon': (isSP || isTB) && isDisplayCertificationIcon
                }"
              >
                <span
                  v-if="isServicePr"
                  class="c-serviceListItemColContentHeader_servicePrLabel"
                >PR</span>
                <p class="c-serviceListItemColContentHeader_overview">
                  {{ serviceName }}
                </p>

                <DLabel
                  class="c-serviceListItemColContentHeader_customizeRequired"
                  v-if="service.service.customizeRequiredFlag && isPC"
                  text-color="Gray900"
                  background-color="Gray25"
                  border-color="Gray25"
                  rounded
                >見積り必須</DLabel>
              </div>
              <h3 class="c-serviceListItemColContentHeader_catchphrase">
                {{ service.service.catchphrase }}
              </h3>
            </template>
            <template v-else>
              <div
                class="c-serviceListItemColContentHeader_firstLine"
                :class="{
                  'c-serviceListItemColContentHeader_firstLine-withIcon': (isSP || isTB) && isDisplayCertificationIcon
                }"
              >
                <span
                  v-if="isServicePr"
                  class="c-serviceListItemColContentHeader_servicePrLabel"
                >PR</span>
                <h3 class="c-serviceListItemColContentHeader_name">
                  {{ $util.truncate(serviceName, descriptionLimitCount) }}
                </h3>
                <DLabel
                  class="c-serviceListItemColContentHeader_customizeRequired"
                  v-if="service.service.customizeRequiredFlag && isPC"
                  text-color="Gray900"
                  background-color="Gray25"
                  border-color="Gray25"
                  rounded
                >見積り必須</DLabel>
              </div>
            </template>
          </div>

          <div class="c-serviceListItemColContentHeader_category">
            <ol>
              <li v-if="isPC">
                <span @click.prevent="toServiceCategory(masterServiceCategory.id)">{{ masterServiceCategory.name }}</span>
              </li>
              <li>
                <span @click.prevent="toServiceCategory(serviceCategory.id)">{{ serviceCategory.name }}</span>
              </li>
              <li v-if="!!serviceCategoryType.name">
                <span @click.prevent="toServiceCategoryType(serviceCategory.id, serviceCategoryType.id)">{{ serviceCategoryType.name }}</span>
              </li>
            </ol>
          </div>

          <div class="c-serviceListItemColContentHeader_descriptionWrapper">
            <p class="c-serviceListItemColContentHeader_description">
              {{ $util.truncate(service.service.head, descriptionLimitCount) }}
            </p>
            <div
              v-if="isLoggedIn && (isPC || isTB || isSP)"
              class="c-serviceListItemColContentHeader_favButton"
            >
              <FavButtonV2
                :is-favorited="service.service.isFavorited"
                :service-id="service.service.id"
                is-always-show
              />
            </div>
          </div>
        </div>

        <div
          class="c-serviceListItemColContent_footer c-serviceListItemColContentFooter"
          :class="{ 'c-serviceListItemColContentFooter-beforeLogin': !isLoggedIn }"
        >
          <div
            v-if="isLoggedIn && (isPC || isTB || isSP)"
            class="c-serviceListItemColContentFooter_favButton"
          >
            <FavButtonV2
              :is-favorited="service.service.isFavorited"
              :service-id="service.service.id"
              is-always-show
            />
          </div>
          <div class="c-serviceListItemColContentFooter_infoUser c-serviceListItemColContentFooterInfoUser">
            <div class="c-serviceListItemColContentFooterInfoUser_level">
              <img
                :src="$coconala.levelIconURL(service.provider.level)"
                alt=""
                loading="lazy"
                decoding="async"
                v-if="service.provider.level > 0"
              >
            </div>
            <div class="c-serviceListItemColContentFooterInfoUser_name">
              <span @click.prevent="toProfile(service.provider.id)">{{ truncateProviderName(service.provider.name) }}</span>
            </div>
          </div>

          <div class="c-serviceListItemColContentFooter_price c-serviceListItemColContentFooterPrice">
            <div class="c-serviceListItemColContentFooterPrice_rating">
              <span class="c-serviceListItemColContentFooterPriceRating">
                <coconala-icon
                  name="star"
                  class="c-serviceListItemColContentFooterPriceRating_star"
                />
                <span
                  class="c-serviceListItemColContentFooterPriceRating_score"
                  v-if="service.service.ratings.indicator"
                >
                  {{ service.service.ratings.indicator.toFixed(1) }}
                </span>
                <span v-else>
                  -
                </span>
              </span>

              <span
                class="c-serviceListItemColContentFooterPriceRating_count"
                v-if="service.service.performanceCount > 0"
              >({{ service.service.performanceCount }})
              </span>
            </div>

            <div class="c-serviceListItemColContentFooterPrice_price">
              <div v-if="service.service.serviceClass === SERVICE_CLASS_PHONE">
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円/分
              </div>
              <div v-else-if="service.service.unitTime">
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円/{{ $util.numberWithDelimiter(service.service.unitTime) }}分
              </div>
              <div v-else>
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="c-serviceListItemCol c-serviceListItemColImage">
        <div class="c-serviceListItemColImage_image">
          <service-image-slide
            :service-id="service.service.id"
            :service-image="service.service.serviceImagesList"
            :service-movie="service.service.serviceMoviesList"
            :movie-priority-flag="Number(service.service.moviePriorityFlag)"
            :layout-type="layoutType"
            box-width="180"
            box-height="150"
            padding-type="calc"
            :url-ref="urlRef"
            :is-loading="isLoading"
            :disabled-lazy-load="itemIndex < IMMEDIATE_LOAD_COUNT"
          />
        </div>
        <div class="c-serviceListItemColImage_labels">
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-standby"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneWait"
          >
            <div class="c-serviceListItemColImageLabel_label">今すぐ<br>相談可能</div>
          </div>
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-reserve"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.service.reservationAvailableFlag"
          >
            <div class="c-serviceListItemColImageLabel_label">予約<br>受付中</div>
          </div>
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-busy"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneTalking"
          >
            <div class="c-serviceListItemColImageLabel_label">相談中</div>
          </div>
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-away"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.isProviderAway"
          >
            <div class="c-serviceListItemColImageLabel_label">離席中</div>
          </div>
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-limit"
            v-if="service.service.fullCorrespondenceFlag"
          >
            <div class="c-serviceListItemColImageLabel_label">満枠<br>対応中</div>
          </div>
          <div
            class="c-serviceListItemColImageLabel c-serviceListItemColImageLabel-stop"
            v-if="service.service.stopFg"
          >
            <div class="c-serviceListItemColImageLabel_label">受付<br>休止中</div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-serviceListItemColFlag">
      <img
        src="@/assets/images/common/icon-video-service.svg"
        alt=""
        loading="lazy"
        decoding="async"
        v-if="service.service.videoType === VIDEO_TYPE"
        class="c-serviceListItemColFlag_image"
      />
      <img
        src="@/assets/images/common/icon-phone-service.svg"
        alt=""
        loading="lazy"
        decoding="async"
        v-if="service.service.serviceClass === SERVICE_CLASS_PHONE"
        class="c-serviceListItemColFlag_image"
      />
    </div>
  </div>
</template>
<script>
import ServiceImageSlide from '~/components/molecules/ServiceImageSlide'
import FavButtonV2 from '~/components/molecules/buttons/FavButtonV2'
import ProIcon from '~/components/molecules/ProIcon'
import DLabel from '~/components/atoms/DS2/DLabel'
import DivinationIcon from '~/components/molecules/Divination'
import { mapGetters } from 'vuex'

const SERVICE_CLASS_PHONE = 1
const VIDEO_TYPE = 2
/** 即時ロードする画像数 */
const IMMEDIATE_LOAD_COUNT = 4

export default {
  name: 'ServiceListItemV2',
  components: {
    ServiceImageSlide,
    FavButtonV2,
    ProIcon,
    DLabel,
    DivinationIcon
  },
  props: {
    itemIndex: {
      type: Number,
      default: 0
    },
    service: {
      type: Object
    },
    condition: {
      type: Object,
      default() {
        return {}
      }
    },
    layoutType: {
      type: String,
      default: 'List'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    urlRef: {
      type: Object
    },
    isServicePr: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      SERVICE_CLASS_PHONE,
      VIDEO_TYPE,
      IMMEDIATE_LOAD_COUNT
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    serviceName() {
      if (this.service.service.overview) {
        return this.service.service.overview
      }
      return this.service.service.name
    },
    masterServiceCategory() {
      return {
        id: this.service.service.masterParentCategoryId,
        name: this.service.service.masterParentCategoryName
      }
    },
    serviceCategory() {
      return {
        id: this.service.service.masterChildCategoryId,
        name: this.service.service.masterChildCategoryName
      }
    },
    serviceCategoryType() {
      return {
        id: this.service.service.masterCategoryTypeId,
        name: this.service.service.masterCategoryTypeName
      }
    },
    descriptionLimitCount() {
      return !this.isSP && !this.isTB ? 90 : 40 // 説明文の字数がこれを超えたら省略する
    },
    // NOTE: なんらかの認定アイコンが表示されているか
    // 現在（2021/11/19）だとPRO、占い認定
    isDisplayCertificationIcon() {
      return (
        this.service.service.certificationDivinationServiceFlag ||
        this.service.service.proServiceFlag
      )
    }
  },
  methods: {
    truncateProviderName(name) {
      if (this.isSP) {
        return this.$util.truncate(name, 5)
      }
      return name
    },
    toServiceCategory(id) {
      location.href = `/categories/${id}`
    },
    toServiceCategoryType(categoryId, categoryTypeId) {
      location.href = `/categories/${categoryId}/${categoryTypeId}`
    },
    toProfile(id) {
      open('/users/' + id, '_blank', 'noopener')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceListItemColFlag {
  position: absolute;
  top: 16px;
  right: 0;
  z-index: 10;

  &_image {
    width: 36px;
    height: 36px;
  }
}
.c-serviceListItemList {
  position: relative;
  display: flex;
  border-bottom: 1px solid $color-gray-100;
  color: $ds2-color-gray-900;

  flex-basis: 100%;
  justify-content: space-between;

  &_inner {
    position: relative;
    width: 100%;
  }

  a {
    @include link-effect;
  }

  /deep/ .c-staticImage_thumbnailImage {
    height: 150px;
  }
}

.c-serviceListItemRow {
  display: flex;
  padding: 16px 0;

  flex-basis: 100%;
  justify-content: space-between;
}

.c-serviceListItemColUser {
  margin-right: 16px;

  flex-basis: 50px;

  &_icon {
    overflow: hidden;
    width: 50px;
    height: 50px;
    text-align: center;

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }

  &_certificationIcon {
    margin-top: 8px;
    height: 29px;
    text-align: center;

    /deep/ .c-proIcon {
      margin: 0 auto;
      text-align: center;
    }
  }

  &_labels {
    margin-top: 8px;
    text-align: center;
  }
}

.c-serviceListItemColContent {
  flex: 1;
}

.c-serviceListItemColImage {
  position: relative;
  margin-left: 24px;
  border: 1px solid $color-beige-50;

  align-self: flex-start;
  flex-basis: 180px;

  &_image {
    width: 180px;
    height: 150px;
  }

  &_labels {
    display: none;
  }
}

.c-serviceListItemImage {
  position: relative;
  width: 180px;
  height: 150px;
  border: 1px solid $color-gray-50;

  img {
    width: 180px;
    height: 150px;
  }
}

.c-serviceListItemColContentHeader {
  &_title {
    width: 680px;
    line-height: 1;
  }

  &_certificationIcon {
    display: none;
  }

  &_firstLine {
    display: flex;

    align-items: center;
  }

  &_overview {
    @include link-effect;

    overflow: hidden;
    margin-bottom: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
    line-height: 1.2;
  }

  &_servicePrLabel {
    font-size: 10px;
    line-height: 1;
    color: $ds2-color-gray-600;
    padding: 1px 4px;
    border: 1px solid $ds2-color-gray-200;
    border-radius: 2px;
    margin-right: 4px;
  }

  &_catchphrase {
    @include link-effect;

    display: block;
    overflow: hidden;
    margin-top: 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.5;
  }

  &_name {
    @include link-effect;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
  }

  &_customizeRequired {
    margin-left: 4px;
    min-width: 74px;
    height: 19px;
    text-align: center;
    font-size: 10px;
    line-height: 1.3;
  }

  &_category {
    margin-top: 8px;
    color: $ds2-color-gray-400;
    font-size: 10px;
    > ol {
      display: flex;
      white-space: nowrap;
      li {
        @include link-effect;

        &:not(:first-child) {
          overflow: hidden;
          text-overflow: ellipsis;
          &::before {
            margin: 0 4px;
            content: '>';
          }
        }
      }
    }
  }

  &_descriptionWrapper {
    display: flex;

    align-items: center;
    justify-content: space-between;
  }

  &_description {
    overflow: hidden;
    margin: 8px 0 12px;
    height: 3em;
    color: $ds2-color-gray-700;
    font-size: 13px;
  }

  &_favButton {
    margin-left: 24px;
  }
}

.c-serviceListItemColContentFooter {
  display: flex;
  line-height: 1;

  align-items: center;
  justify-content: space-between;

  &_favButton {
    display: none;
  }
}

.c-serviceListItemColContentFooterInfoUser {
  display: flex;

  align-items: center;

  &_name {
    display: inline-flex;
    color: $ds2-color-gray-700;
    font-size: 11px;

    align-items: center;

    span {
      display: inline-block;
      overflow: hidden;
      margin-bottom: 1px;
      max-width: 140px;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 11px;
      line-height: 1.4;
    }
  }

  &_level {
    position: relative;
    display: inline-flex;
    align-items: center;

    img {
      margin-right: 4px;
      width: 24px;
    }
  }
}

.c-serviceListItemColImageLabel {
  bottom: 0;
  z-index: 10;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 16px;

  align-items: center;
  justify-content: center;

  &-standby {
    background: $ds2-color-coconala-orange;
    color: $color-white;
  }

  &-busy {
    background: $ds2-color-brand-secondary;
    color: $color-white;
  }

  &-away {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &-reserve {
    border: solid 1px $ds2-color-coconala-orange;
    background: $color-white;
    color: $ds2-color-coconala-orange;
  }

  &-limit {
    background: $ds2-color-red;
    color: $color-white;
  }

  &-stop {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &_label {
    font-size: 11px;
    line-height: 12px;
  }
}

.c-serviceListItemColContentFooterPrice {
  position: relative;
  display: flex;
  flex: 1;
  margin-left: 4px;

  align-items: flex-end;
  justify-content: space-between;

  &_rating {
    display: flex;

    align-items: center;
  }

  &_price {
    color: $ds2-color-gray-900;
    font-size: 12px;

    strong {
      padding-right: 2px;
      font-weight: bold;
      font-size: 20px;
    }
  }
}

.c-serviceListItemColContentFooterPriceRating {
  display: inline-flex;
  height: 20px;
  font-size: 13px;

  align-items: center;

  &_star {
    margin-right: 2px;
    margin-bottom: 2px;
    color: $ds2-color-orange;
    font-size: 15px;
    line-height: 0.5;
  }

  &_score {
    // safariで崩れるのを防止
    height: 14px;
    color: $ds2-color-orange;
    font-weight: bold;
    font-size: 15px;
  }

  &_count {
    margin-left: 2px;
    color: $ds2-color-gray-900;
    font-size: 11px;
  }
}

.c-serviceListItemColUserLabel {
  display: flex;
  box-sizing: border-box;
  margin-bottom: 2px;
  width: 50px;
  height: 26px;
  border-radius: 2px;
  line-height: 1.18em;

  align-items: center;
  justify-content: center;

  &-standby {
    background: $ds2-color-coconala-orange;
    color: $color-white;
  }

  &-busy {
    background: $ds2-color-brand-secondary;
    color: $color-white;
  }

  &-away {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &-reserve {
    border: solid 1px $ds2-color-coconala-orange;
    background: $color-white;
    color: $ds2-color-coconala-orange;
  }

  &-limit {
    background: $ds2-color-red;
    color: $color-white;
  }

  &-stop {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &_label {
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 10px;
    line-height: 10px;
  }
}

@media (min-width: breakpoint(Search, M) + 1) and (max-width: breakpoint(Search, XL) - 1) {
  .c-serviceListItemColContentHeader {
    &_title {
      width: 440px;
    }
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-serviceListItem {
    position: relative;
  }
  .c-serviceListItemColFlag {
    top: 0;
    right: 0;

    &_image {
      width: 32px;
      height: 32px;
    }
  }

  .c-serviceListItemList {
    padding: 8px 0;

    /deep/ .c-staticImage_thumbnailImage {
      height: unset;
    }
  }

  .c-serviceListItemRow {
    padding: 0;

    &_favButton {
      bottom: 9px;
      left: 12px;
      width: 24px;
    }
  }

  .c-serviceListItemColUser {
    display: none;
  }

  .c-serviceListItemColContent {
    padding-left: 12px;
    width: 100%;
  }

  .c-serviceListItemColImage {
    position: absolute;
    top: 2px;
    right: 0;
    margin: 0 12px 0 4px;
    width: 102px;

    align-self: flex-start;
    flex-basis: 102px;

    &_image {
      width: 100px;
      height: 84px;
    }

    &_labels {
      position: absolute;
      bottom: -1px;
      left: 0;
      z-index: 10;
      display: block;
      width: 100%;
      height: 16px;
    }
  }

  .c-serviceListItemColImageLabel {
    &_label {
      & > br {
        display: none;
      }
    }
  }

  .c-serviceListItemColContentHeader {
    padding-right: 124px;
    min-height: 96px;

    &_title {
      width: auto;
      &-withIcon {
        display: flex;
        flex-direction: row-reverse;

        flex-wrap: wrap;
        justify-content: flex-end;
      }
    }

    &_firstLine {
      display: inline-block;
      width: 100%;
      &-withIcon {
        margin-top: 3px;
        width: calc(100% - 30px);
      }
    }

    &_certificationIcon {
      position: relative;
      top: 3px;
      display: inline-block;
      overflow: hidden;
      margin-right: 6px;
      margin-bottom: 5px;
    }

    &_overview {
      display: inline;
      white-space: normal;
      font-weight: bold;
      font-size: 14px;
    }
    &_servicePrLabel {
      font-size: 10px;
      position: relative;
      bottom: 1px;
    }

    &_catchphrase {
      white-space: normal;
      font-size: 14px;
    }

    &_name {
      display: inline;
      white-space: normal;
      font-size: 14px;
    }

    &_customizeRequired {
      display: none;
    }

    &_descriptionWrapper {
      display: none;
    }
  }

  .c-serviceListItemColContentFooter {
    margin-top: 8px;

    &-beforeLogin {
      margin-left: 0;
    }

    &_favButton {
      display: block;
      margin-right: 12px;
    }
  }

  .c-serviceListItemColContentFooterInfoUser {
    &_name {
      span {
        margin-left: 0;
        margin-bottom: 0;
      }
    }

    &_level {
      img {
        margin-right: 2px;
        margin-left: 0;
        width: 22px;
      }
    }
  }
  .c-serviceListItemColContentFooterPrice {
    flex: 1;
    margin: 0 12px 0 4px;

    &_price {
      strong {
        font-size: 17px;
      }
    }
  }
  .c-serviceListItemColContentFooterPriceRating {
    &_star {
      margin-right: 2px;
      height: 14px;
      line-height: 0;
    }
    &_count {
      margin-top: 1px;
      line-height: 20px;
    }
  }
}
</style>
